import { invalid } from 'entities/support/utils'
import { z } from 'zod'
export const InviteUserSchema = z.object({
  email: z.string().email({ message: invalid('pattern', 'Email') })
})

export type InviteUserPayload = z.infer<typeof InviteUserSchema>
